import { render } from "./userAgreement.vue?vue&type=template&id=629e6149"
import script from "./userAgreement.vue?vue&type=script&lang=js"
export * from "./userAgreement.vue?vue&type=script&lang=js"

import "./userAgreement.vue?vue&type=style&index=0&id=629e6149&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__